import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaFileAlt, FaCalendarTimes } from "react-icons/fa";
import { documentsList } from "../../../helpers/DocumentsList";
import constants from "../../../constants";
import { format } from "date-fns";
import { redirectUrl } from "../../../services/GlobalUrls";
import LoadMoreList from "../../../services/LoadMoreList";
import { checkIfFileIsaDocument } from "../../../services/FileOperationGlobalFunctions";
import GlobalViewFileModal from "../../../services/GlobalViewFileModal";

const RightToWorkListMobile = (props) => {
  const [rightToWorks, SetRightToWork] = useState([]);
  const [modalOption, setModalOption] = useState(false);
  const [modalHeight, setModalHeight] = useState("500px");
  const [fileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const { progress } = props;

  const [inputValue, setInputValue] = useState("");

  let cndApproved = localStorage.getItem("tempUserStatus");

  useEffect(() => {
    SetRightToWork(props.rightToWorks);
  }, [props.rightToWorks]);

  const viewFileModal = (url, fileName) => {
    if (checkIfFileIsaDocument(url)) {
      setModalHeight("500px");
      setFileUrl(url);
      setFileName(fileName);
    } else {
      redirectUrl(url);
    }
  };

  const callModal = () => {
    document.getElementById("loader").style.display = "block";
    setModalOption(true);
  };
  const loaderEnd = () => {
    document.getElementById("loader").style.display = "none";
    setModalHeight("auto");
  };
  // const loaderEnd = () => {
  //   document.getElementById("loader").style.display = "none";
  //   setModalOption(true);
  //   setModalHeight("auto");
  // };
  const closeFileModal = () => {
    setModalOption(false);
    setFileUrl("");
  };

  const dateDiffrence = (date) => {
    const date1 = new Date();
    const date2 = new Date(splitDateToFormat(date));
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const splitDateToFormat = (date) => {
    let splitDate = date.split("-");
    let formattedDate = splitDate[2] + "-" + splitDate[1] + "-" + splitDate[0];
    return formattedDate;
  };

  // Useffect For Scroll Start

  const isMobileOrLaptop = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile =
      /mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        userAgent,
      );

    if (isMobile) {
      return "Mobile";
    } else {
      const isTablet = /android|ipad|tablet/i.test(userAgent);
      if (isTablet) {
        return "Tablet";
      } else {
        return "Laptop/Desktop";
      }
    }
  };
  let scrollFocusElement;
  useEffect(() => {
    scrollFocusElement = document.getElementById("scrollFocusElement");
    const deviceType = isMobileOrLaptop();
    // console.log('Device Type:', deviceType);
    if (deviceType == "Mobile" || deviceType == "Tablet") {
      window.scrollTo(0, 900);
    }
  }, [scrollFocusElement]);
  // UseEffect For Scroll Stop

  const documentsRequiredCall = () => {
    let urlRed = "";
    if (
      progress.progress_bar_compliance_7 === null ||
      progress.progress_bar_compliance_7 === 0 ||
      progress.progress_bar_compliance_7 === "0"
    ) {
      if (!progress.cnd_compliance_doc_master_id) {
        urlRed = "/create-document-address1";
      } else if (
        progress.cnd_compliance_doc_master_id &&
        progress.cnd_compliance_doc_master_id === "address1"
      ) {
        urlRed = "/create-document-address2";
      } else if (
        progress.cnd_compliance_doc_master_id &&
        progress.cnd_compliance_doc_master_id === "address2"
      ) {
        urlRed = "/create-document-national-insurance";
      } else if (
        progress.cnd_compliance_doc_master_id &&
        progress.cnd_compliance_doc_master_id == "nationalinsurance"
      ) {
        urlRed = "/create-document-police-clearnace-certificate";
      } else {
        urlRed = "/document-required";
      }
    }
    // console.log("Master Id => ", progress.progress_bar_compliance_7,progress.cnd_compliance_doc_master_id ,urlRed);
    redirectUrl(urlRed ? urlRed : "/document-required");
  };

  const matchesSearchText = (rightToWork) => {
    const searchText = inputValue.toLowerCase();
    return (
      rightToWork.cnd_rightwork_created_date
        .toLowerCase()
        .includes(searchText) ||
      documentsList[rightToWork.cnd_rightwork_document_master_id]
        .toLowerCase()
        .includes(searchText) ||
      rightToWork.cnd_rightwork_expire_date.toLowerCase().includes(searchText)
    );
  };

  // Filter applied jobs based on the search text
  const filterRows = rightToWorks ? rightToWorks.filter(matchesSearchText) : [];

  return (
    <React.Fragment>
      <div className="row m-b30" id="scrollFocusElement">
        {/* Search Start */}
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group form-group-default">
                <input
                  type="text"
                  name="search"
                  className="form-control "
                  placeholder="Search here"
                  id="myInput"
                  onInput={(event, value) => {
                    setInputValue(event.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        {/* Search End */}
        <div className="col-lg-12 col-md-12 m-b0 wrapper">
          <LoadMoreList
            data={filterRows}
            initialCount={5}
            noDataMessage="No Result Found"
            renderItem={(work, i) => (
              <ul
                className="nav navbar-nav border border-grey p-4 mb-2"
                style={{ borderRadius: "20px" }}
                key={i}
              >
                <li className="text-dark">
                  <FaCalendarAlt className="mr-1 text-primary" />{" "}
                  {work.cnd_rightwork_created_date}
                </li>
                <li className="text-dark">
                  <FaFileAlt className="mr-1 text-primary" />{" "}
                  <a
                    onClick={() =>
                      viewFileModal(
                        constants.IMAGE_URL +
                          work.cnd_rightwork_folder_path +
                          work.cnd_rightwork_upload_file,
                        documentsList[work.cnd_rightwork_document_master_id],
                      )
                    }
                    className="text-primary"
                  >
                    <u>
                      {work.cnd_rightwork_document_master_id
                        ? documentsList[
                            work.cnd_rightwork_document_master_id
                          ] &&
                          String(
                            documentsList[
                              work.cnd_rightwork_document_master_id
                            ],
                          ).length <= 20
                          ? documentsList[work.cnd_rightwork_document_master_id]
                          : String(
                              documentsList[
                                work.cnd_rightwork_document_master_id
                              ],
                            ).slice(0, 20) + "..."
                        : ""}
                    </u>
                  </a>
                  <a
                    onClick={() =>
                      viewFileModal(
                        constants.IMAGE_URL +
                          work.cnd_rightwork_folder_path +
                          work.cnd_rightwork_upload_file,
                        documentsList[work.cnd_rightwork_document_master_id],
                      )
                    }
                    className="text-primary text-sm pull-right mt--2"
                  >
                    <u>View File</u>
                  </a>
                </li>
                <li className="text-dark">
                  <FaCalendarTimes className="mr-1 text-primary" />{" "}
                  {work.cnd_rightwork_expire_date}
                </li>
                <li
                  className={
                    new Date() <=
                      new Date(
                        splitDateToFormat(work.cnd_rightwork_expire_date),
                      ) && dateDiffrence(work.cnd_rightwork_expire_date) > 30
                      ? "text-success"
                      : new Date() <=
                            new Date(
                              splitDateToFormat(work.cnd_rightwork_expire_date),
                            ) &&
                          dateDiffrence(work.cnd_rightwork_expire_date) < 30
                        ? "text-warning"
                        : "text-danger"
                  }
                >
                  <i className="fa fa-circle-o-notch mr-1"></i>{" "}
                  {new Date() <=
                    new Date(
                      splitDateToFormat(work.cnd_rightwork_expire_date),
                    ) && dateDiffrence(work.cnd_rightwork_expire_date) > 30
                    ? "Valid"
                    : new Date() <=
                          new Date(
                            splitDateToFormat(work.cnd_rightwork_expire_date),
                          ) &&
                        dateDiffrence(work.cnd_rightwork_expire_date) < 30
                      ? "About to Expire"
                      : "Expired"}
                </li>
              </ul>
            )}
          />
          <a
            href="#"
            onClick={documentsRequiredCall}
            className="pull-right btn btn-primary mr-2"
          >
            Next
          </a>
        </div>
      </div>
      <GlobalViewFileModal
        modalOption={modalOption}
        closeFileModal={closeFileModal}
        fileUrl={fileUrl}
        fileName={fileName}
        loaderEnd={loaderEnd}
        modalHeight={modalHeight}
        callModal={callModal}
        // title={"Right To Work"}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    rightToWorks: state.rightToWorks.rightToWorks,
    progress: state.progress.progress,
  };
};

export default connect(mapStateToProps)(RightToWorkListMobile);
